import React, { Component } from 'react'

class ReduxSplitInputContainer extends Component {

  renderLabel(label) {
    return label
    ? (
        <label>{label}</label>
      )
    : ''
  }

  render() {
    const {
      children,
      label,
      optionalClasses
    } = this.props

    return (
      <div className={`split-input-container redux-form${optionalClasses ? ' ' +optionalClasses : ''}`}>
        {this.renderLabel(label)}
        {children}
      </div>
    )
  }
}

export default ReduxSplitInputContainer



// WEBPACK FOOTER //
// ./src/components/Global/ReduxForms/ReduxSplitInputContainer.js